import { render } from "./FasterholtSms.vue?vue&type=template&id=5ff7be28"
import script from "./FasterholtSms.vue?vue&type=script&lang=js"
export * from "./FasterholtSms.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__